export default import.meta.ROLLDOWN_FILE_URL_HGaAMAHLy$_BD_h4Jc_LCw